import React from 'react'
import LeaderboardsStore from './../../store/LeaderboardsPage.store'
import CurrentTopPipAgents from './../CurrentTopPipAgents/CurrentTopPipAgents.component'
import CurrentTopPipEliteAgencyTeams from './../CurrentTopPipEliteAgencyTeams/CurrentTopPipEliteAgencyTeams.component'

import './CurrentTopPip.scss'

const TOGGLE_PIP_WIDGETS = false

const CurrentTopPip = () =>
  TOGGLE_PIP_WIDGETS ? (
    LeaderboardsStore.fetchParams.agent_type === 'elite_agency_team_id' ? (
      <CurrentTopPipEliteAgencyTeams />
    ) : (
      <CurrentTopPipAgents />
    )
  ) : (
    <>
      <CurrentTopPipAgents />
      <CurrentTopPipEliteAgencyTeams />
    </>
  )

export default CurrentTopPip
